import { css } from '@emotion/core';
import React from 'react';
import {
  ContentfulImageHeadingAndShortText,
  ContentfulImageAndText,
} from '../../graphql-types';
import { ReactComponent as TopWave } from '../../assets/svgs/doctors/advisorsTop.svg';
import { ReactComponent as BottomWave } from '../../assets/svgs/doctors/advisorsBottom.svg';
import DotsTestimonial from '../common/sections/DotsTestimonial';

interface Props {
  header: ContentfulImageHeadingAndShortText;
  testimonials: ContentfulImageAndText[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style?: any;
}

const sectionStyle = css`
  padding: 30px 0;
  background-color: #d2eedd;
  text-align: center;
  cursor: grab;

  .slick-next:before,
  .slick-prev:before {
    content: '';
  }

  div:focus {
    outline: none;
  }
`;

const TestimonialsSection: React.FC<Props> = ({
  header,
  testimonials,
  style,
}) => {
  return (
    <div css={style}>
      <TopWave
        width="100vw"
        height="auto"
        css={{
          display: 'block',
          width: '100%',
          height: 'auto',
          marginTop: 70,
        }}
      />
      <div css={sectionStyle}>
        <DotsTestimonial header={header} testimonials={testimonials} />
      </div>
      <BottomWave
        width="100%"
        height="83"
        css={{ width: '100%', height: 'auto', marginBottom: 0 }}
      />
    </div>
  );
};

export default TestimonialsSection;
